import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { TasksService } from "../../services/tasks.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { ErrorHandlerService } from "src/app/shared/error-handler.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import Swal from "sweetalert2";

interface TaskResponse {
  id: string;
  title: string;
  description: string;
  personName: string;
  status: string;
  startDate?: string;
  endDate?: string;
  createdAt?: string;
  updatedAt?: string;
}

@Component({
  selector: "app-tasks-list",
  templateUrl: "./tasks-list.component.html",
  styleUrls: ["./tasks-list.component.css"],
})
export class TasksListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ["title", "personName", "startDate", "endDate", "status", "actions"];
  dataSource = new MatTableDataSource<TaskResponse>([]);
  loading = false;

  currentPage = 0;
  pageSize = 10;
  totalElements = 0;
  sortField = "title";
  sortDirection = "asc";
  filterValue = "";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private tasksService: TasksService,
    private toast: ToastrService,
    public router: Router,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  ngOnInit(): void {
    this.loadTasks();
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe((sort: Sort) => this.onSortChange(sort));
  }

  private loadTasks(): void {
    this.loading = true;
    this.tasksService.findAll(this.currentPage, this.pageSize, this.sortField, this.sortDirection).subscribe({
      next: (response) => {
        if (response) {
          this.dataSource.data = response.content;
          this.totalElements = response.totalElements;
        }
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.errorHandlerService.handle(error, "Erro ao buscar as tarefas");
      },
    });
  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadTasks();
  }

  onSortChange(sort: Sort): void {
    this.sortField = sort.active;
    this.sortDirection = sort.direction || "asc";
    this.currentPage = 0;
    this.loadTasks();
  }

  applyFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = value;
  }

  statusLabel(status: string): string {
    const labels: Record<string, string> = {
      pending: "Pendente",
      pendente: "Pendente",
      in_progress: "Em Andamento",
      done: "Concluída",
      concluida: "Concluída",
      cancelled: "Cancelada",
      cancelada: "Cancelada",
    };
    return labels[status?.toLowerCase()] ?? status;
  }

  onEdit(task: TaskResponse): void {
    this.router.navigate(["/tasks/edit/", task.id]);
  }

  onDelete(task: TaskResponse): void {
    Swal.fire({
      title: `Tem certeza que deseja excluir a tarefa "${task.title}"?`,
      text: "Você não poderá voltar atrás após excluir!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir agora!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.tasksService.delete(task.id).subscribe({
          next: () => {
            this.toast.success(`A tarefa ${task.title} foi excluída com sucesso.`);
            this.loadTasks();
          },
          error: (error) => {
            this.loading = false;
            this.errorHandlerService.handle(error, "Erro ao excluir tarefa selecionada.");
          },
        });
      }
    });
  }
}
